<template>
  <div id="article" :class="isFull === 1 ? 'article0 top_information_fixed1' : 'article1'">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="title"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      class="custom-nav-bar"
    />
    <!-- 信息-->
    <div class="article-content">
        <div v-html="centent">
    </div>
    </div>
  </div>
</template>

<script>
import '../assets/css/style.css'
import axios from 'axios'

export default {
  name: 'RedOrder',
  data() {
    return {
      centent: '',
      title: '',
      isFull: 0
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0
    this.getList()
  },
  methods: {
    goBack() {
        if (this.$route.query.source =='h5') {
            this.$router.go(-1)
        }else{
             // 拦截关闭h5
            window.location.href="bogolive://exit"
        }
    },
    getList() {
        const token = this.$route.query.token
        const id = this.$route.query.id
        const cate_id = this.$route.query.cate_id
        this.loading = true
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=article_list", {
        params: {
          token: token,
          id: id,
          cate_id: cate_id
        }
      }).then(res => {
         this.loading = false
         this.title = res.data.data.title
         this.centent = res.data.data.content
      }).catch(err => {
        console.error('获取红包信息失败:', err)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article.vue